import { oBalloon } from "./plants/oBalloon.js";
import { oBigChomper } from "./plants/oBigChomper.js";
import { oBoomNutBowling } from "./plants/oBoomNutBowling.js";
import { oBrains } from "./plants/oBrains.js";
import { oCFlowerPot } from "./plants/oCFlowerPot.js";
import { oCactus } from "./plants/oCactus.js";
import { oCattail } from "./plants/oCattail.js";
import { oCherryBomb } from "./plants/oCherryBomb.js";
import { oChomper } from "./plants/oChomper.js";
import { oCleaner } from "./plants/oCleaner.js";
import { oCleaner1 } from "./plants/oCleaner1.js";
import { oCoffeeBean } from "./plants/oCoffeeBean.js";
import { oDoomShroom } from "./plants/oDoomShroom.js";
import { oFlowerPot } from "./plants/oFlowerPot.js";
import { oFlowerVase } from "./plants/oFlowerVase.js";
import { oFumeShroom } from "./plants/oFumeShroom.js";
import { oGarlic } from "./plants/oGarlic.js";
import { oGatlingPea } from "./plants/oGatlingPea.js";
import { oGloomShroom } from "./plants/oGloomShroom.js";
import { oGoldenPrize } from "./plants/oGoldenPrize.js";
import { oGraveBuster } from "./plants/oGraveBuster.js";
import { oGun } from "./plants/oGun.js";
import { oHugeNutBowling } from "./plants/oHugeNutBowling.js";
import { oHypnoShroom } from "./plants/oHypnoShroom.js";
import { oILilyPad } from "./plants/oILilyPad.js";
import { oIPotatoMine } from "./plants/oIPotatoMine.js";
import { oIceFumeShroom } from "./plants/oIceFumeShroom.js";
import { oIceShroom } from "./plants/oIceShroom.js";
import { oJalapeno } from "./plants/oJalapeno.js";
import { oLaserBean } from "./plants/oLaserBean.js";
import { oLawnCleaner } from "./plants/oLawnCleaner.js";
import { oLilyPad } from "./plants/oLilyPad.js";
import { oLilyPad1 } from "./plants/oLilyPad1.js";
import { oLing } from "./plants/oLing.js";
import { oLotusRoot } from "./plants/oLotusRoot.js";
import { oMagnetShroom } from "./plants/oMagnetShroom.js";
import { oMagneticmuShroom } from "./plants/oMagneticmuShroom.js";
import { oNutBowling } from "./plants/oNutBowling.js";
import { oOG } from "./plants/oOG.js";
import { oOxygen } from "./plants/oOxygen.js";
import { oPeashooter } from "./plants/oPeashooter.js";
import { oPlantern } from "./plants/oPlantern.js";
import { oPoolCleaner } from "./plants/oPoolCleaner.js";
import { oPotatoMine } from "./plants/oPotatoMine.js";
import { oPuffShroom } from "./plants/oPuffShroom.js";
import { oPumpkinHead } from "./plants/oPumpkinHead.js";
import { oRepeater } from "./plants/oRepeater.js";
import { oRepeater2 } from "./plants/oRepeater2.js";
import { oScaredyShroom } from "./plants/oScaredyShroom.js";
import { oSeaAnemone } from "./plants/oSeaAnemone.js";
import { oSeaShroom } from "./plants/oSeaShroom.js";
import { oSeedBlover } from "./plants/oSeedBlover.js";
import { oSeedCactus } from "./plants/oSeedCactus.js";
import { oSeedCherryBomb } from "./plants/oSeedCherryBomb.js";
import { oSeedChomper } from "./plants/oSeedChomper.js";
import { oSeedDoomShroom } from "./plants/oSeedDoomShroom.js";
import { oSeedFumeShroom } from "./plants/oSeedFumeShroom.js";
import { oSeedGarlic } from "./plants/oSeedGarlic.js";
import { oSeedGloomShroom } from "./plants/oSeedGloomShroom.js";
import { oSeedHypnoShroom } from "./plants/oSeedHypnoShroom.js";
import { oSeedIceShroom } from "./plants/oSeedIceShroom.js";
import { oSeedJalapeno } from "./plants/oSeedJalapeno.js";
import { oSeedLilyPad } from "./plants/oSeedLilyPad.js";
import { oSeedPeashooter } from "./plants/oSeedPeashooter.js";
import { oSeedPlantern } from "./plants/oSeedPlantern.js";
import { oSeedPotatoMine } from "./plants/oSeedPotatoMine.js";
import { oSeedPuffShroom } from "./plants/oSeedPuffShroom.js";
import { oSeedPumpkinHead } from "./plants/oSeedPumpkinHead.js";
import { oSeedRepeater } from "./plants/oSeedRepeater.js";
import { oSeedRepeater2 } from "./plants/oSeedRepeater2.js";
import { oSeedScaredyShroom } from "./plants/oSeedScaredyShroom.js";
import { oSeedSeaShroom } from "./plants/oSeedSeaShroom.js";
import { oSeedSnowPea } from "./plants/oSeedSnowPea.js";
import { oSeedSpikeweed } from "./plants/oSeedSpikeweed.js";
import { oSeedSquash } from "./plants/oSeedSquash.js";
import { oSeedStarfruit } from "./plants/oSeedStarfruit.js";
import { oSeedTallNut } from "./plants/oSeedTallNut.js";
import { oSeedTangleKelp } from "./plants/oSeedTangleKelp.js";
import { oSeedThreepeater } from "./plants/oSeedThreepeater.js";
import { oSeedTorchwood } from "./plants/oSeedTorchwood.js";
import { oSeedWallNut } from "./plants/oSeedWallNut.js";
import { oShovel } from "./plants/oShovel.js";
import { oSnowPea } from "./plants/oSnowPea.js";
import { oSnowRepeater } from "./plants/oSnowRepeater.js";
import { oSpikerock } from "./plants/oSpikerock.js";
import { oSpikeweed } from "./plants/oSpikeweed.js";
import { oSplitPea } from "./plants/oSplitPea.js";
import { oSquash } from "./plants/oSquash.js";
import { oStarfruit } from "./plants/oStarfruit.js";
import { oSunFlower } from "./plants/oSunFlower.js";
import { oSunShroom } from "./plants/oSunShroom.js";
import { oTTS } from "./plants/oTTS.js";
import { oTallNut } from "./plants/oTallNut.js";
import { oTangleKlep } from "./plants/oTangleKlep.js";
import { oTenManNut } from "./plants/oTenManNut.js";
import { oThreepeater } from "./plants/oThreepeater.js";
import { oTorchwood } from "./plants/oTorchwood.js";
import { oTwinSunflower } from "./plants/oTwinSunflower.js";
import { oWallNut } from "./plants/oWallNut.js";
import { oBlover } from "./plants/oBlover.js";
import { oFlamesMushroom } from "./plants/oFlamesMushroom.js";
import { ostar } from "./plants/ostar.js";
import { ostar1 } from "./plants/ostar1.js";

const plants = {
	CPlants: CPlants,
	oBalloon: oBalloon,
	oBigChomper: oBigChomper,
	oBlover: oBlover,
	oBoomNutBowling: oBoomNutBowling,
	oBrains: oBrains,
	oCFlowerPot: oCFlowerPot,
	oCactus: oCactus,
	oCattail: oCattail,
	oCherryBomb: oCherryBomb,
	oChomper: oChomper,
	oCleaner: oCleaner,
	oCleaner1: oCleaner1,
	oCoffeeBean: oCoffeeBean,
	oDoomShroom: oDoomShroom,
	oFlamesMushroom: oFlamesMushroom,
	oFlowerPot: oFlowerPot,
	oFlowerVase: oFlowerVase,
	oFumeShroom: oFumeShroom,
	oGarlic: oGarlic,
	oGatlingPea: oGatlingPea,
	oGloomShroom: oGloomShroom,
	oGoldenPrize: oGoldenPrize,
	oGraveBuster: oGraveBuster,
	oGun: oGun,
	oHugeNutBowling: oHugeNutBowling,
	oHypnoShroom: oHypnoShroom,
	oILilyPad: oILilyPad,
	oIPotatoMine: oIPotatoMine,
	oIceFumeShroom: oIceFumeShroom,
	oIceShroom: oIceShroom,
	oJalapeno: oJalapeno,
	oLaserBean: oLaserBean,
	oLawnCleaner: oLawnCleaner,
	oLilyPad: oLilyPad,
	oLilyPad1: oLilyPad1,
	oLing: oLing,
	oLotusRoot: oLotusRoot,
	oMagnetShroom: oMagnetShroom,
	oMagneticmuShroom: oMagneticmuShroom,
	oNutBowling: oNutBowling,
	oOG: oOG,
	oOxygen: oOxygen,
	oPeashooter: oPeashooter,
	oPlantern: oPlantern,
	oPoolCleaner: oPoolCleaner,
	oPotatoMine: oPotatoMine,
	oPuffShroom: oPuffShroom,
	oPumpkinHead: oPumpkinHead,
	oRepeater: oRepeater,
	oRepeater2: oRepeater2,
	oScaredyShroom: oScaredyShroom,
	oSeaAnemone: oSeaAnemone,
	oSeaShroom: oSeaShroom,
	oSeedBlover: oSeedBlover,
	oSeedCactus: oSeedCactus,
	oSeedCherryBomb: oSeedCherryBomb,
	oSeedChomper: oSeedChomper,
	oSeedDoomShroom: oSeedDoomShroom,
	oSeedFumeShroom: oSeedFumeShroom,
	oSeedGarlic: oSeedGarlic,
	oSeedGloomShroom: oSeedGloomShroom,
	oSeedHypnoShroom: oSeedHypnoShroom,
	oSeedIceShroom: oSeedIceShroom,
	oSeedJalapeno: oSeedJalapeno,
	oSeedLilyPad: oSeedLilyPad,
	oSeedPeashooter: oSeedPeashooter,
	oSeedPlantern: oSeedPlantern,
	oSeedPotatoMine: oSeedPotatoMine,
	oSeedPuffShroom: oSeedPuffShroom,
	oSeedPumpkinHead: oSeedPumpkinHead,
	oSeedRepeater: oSeedRepeater,
	oSeedRepeater2: oSeedRepeater2,
	oSeedScaredyShroom: oSeedScaredyShroom,
	oSeedSeaShroom: oSeedSeaShroom,
	oSeedSnowPea: oSeedSnowPea,
	oSeedSpikeweed: oSeedSpikeweed,
	oSeedSquash: oSeedSquash,
	oSeedStarfruit: oSeedStarfruit,
	oSeedTallNut: oSeedTallNut,
	oSeedTangleKelp: oSeedTangleKelp,
	oSeedThreepeater: oSeedThreepeater,
	oSeedTorchwood: oSeedTorchwood,
	oSeedWallNut: oSeedWallNut,
	oShovel: oShovel,
	oSnowPea: oSnowPea,
	oSnowRepeater: oSnowRepeater,
	oSpikerock: oSpikerock,
	oSpikeweed: oSpikeweed,
	oSplitPea: oSplitPea,
	oSquash: oSquash,
	oStarfruit: oStarfruit,
	oSunFlower: oSunFlower,
	oSunShroom: oSunShroom,
	oTTS: oTTS,
	oTallNut: oTallNut,
	oTangleKlep: oTangleKlep,
	oTenManNut: oTenManNut,
	oThreepeater: oThreepeater,
	oTorchwood: oTorchwood,
	oTwinSunflower: oTwinSunflower,
	oWallNut: oWallNut,
	ostar: ostar,
	ostar1: ostar1,
};
Object.keys(plants).forEach((plantName) => {
	window[plantName] = plants[plantName];
});
